import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
export type Common_AnalysisLayoutColumn_FragmentFragment = {
  __typename: 'AnalysisLayoutColumn'
  columnId: string
  columnName: string
  columnType: Types.HandleAnalysisLayoutColumnType
}

export type Common_AnalysisLocationInSightType_FragmentFragment = {
  __typename: 'AnalysisLocationInSightType'
  locationInsightType: Types.LocationInsightType
  columnIds: Array<string>
}

export type Common_AnalysisLayout_FragmentFragment = {
  __typename: 'AnalysisLayout'
  layoutId: Types.HandleAnalysisLayoutEnum
  layoutType: Types.HandleAnalysisLayoutType
  title: string
  description?: string | null
  columnIds: Array<string>
}

export type Common_AnalysisSection_FragmentFragment = {
  __typename: 'AnalysisSection'
  sectionId: Types.HandleAnalysisSectionEnum
  title: string
  description?: string | null
  layoutIds: Array<Types.HandleAnalysisLayoutEnum>
}

export type Common_AnalysisTab_FragmentFragment = {
  __typename: 'AnalysisTab'
  tabId: Types.HandleAnalysisTabEnum
  title: string
  sectionIds: Array<Types.HandleAnalysisSectionEnum>
}

export type Common_CdrAnalysis_FragmentFragment = {
  __typename: 'CDRAnalysis'
  analysisId: string
  title: string
  telecomServiceProvider: string
  dataReceivedAt: string
}

export type Common_TelegramAnalysis_FragmentFragment = {
  __typename: 'TelegramAnalysis'
  analysisId: string
  analysisType: Types.AnalysisType
  title: string
  dataReceivedAt: string
}

export type Common_WhatsAppAnalysis_FragmentFragment = {
  __typename: 'WhatsAppAnalysis'
  analysisId: string
  analysisType: Types.AnalysisType
  title: string
  dataReceivedAt: string
  dateRange: {
    __typename: 'WhatsAppAnalysisDateRange'
    startDatetime: string
    endDatetime: string
  }
}

export type Common_AnalysisViewConfig_FragmentFragment = {
  __typename: 'AnalysisViewConfig'
  tabs: Array<{
    __typename: 'AnalysisTab'
    tabId: Types.HandleAnalysisTabEnum
    title: string
    sectionIds: Array<Types.HandleAnalysisSectionEnum>
  }>
  sections: Array<{
    __typename: 'AnalysisSection'
    sectionId: Types.HandleAnalysisSectionEnum
    title: string
    description?: string | null
    layoutIds: Array<Types.HandleAnalysisLayoutEnum>
  }>
  layouts: Array<{
    __typename: 'AnalysisLayout'
    layoutId: Types.HandleAnalysisLayoutEnum
    layoutType: Types.HandleAnalysisLayoutType
    title: string
    description?: string | null
    columnIds: Array<string>
  }>
  columns: Array<{
    __typename: 'AnalysisLayoutColumn'
    columnId: string
    columnName: string
    columnType: Types.HandleAnalysisLayoutColumnType
  }>
}

export type Common_Tag_FragmentFragment = {
  __typename: 'Tag'
  tagId: string
  name: string
  color?: Types.ColorEnum | null
  order: number
}

export type Common_AnalysisReportResponseValue_Fragment_GqlDateTimeType_Fragment =
  { __typename: 'GQLDateTimeType'; DateTimeValue?: string | null }

export type Common_AnalysisReportResponseValue_Fragment_GqlFloatType_Fragment =
  { __typename: 'GQLFloatType'; floatValue?: number | null }

export type Common_AnalysisReportResponseValue_Fragment_GqlIntType_Fragment = {
  __typename: 'GQLIntType'
  IntValue?: number | null
}

export type Common_AnalysisReportResponseValue_Fragment_GqlListTag_Fragment = {
  __typename: 'GQLListTag'
  tags: Array<{
    __typename: 'Tag'
    tagId: string
    name: string
    color?: Types.ColorEnum | null
    order: number
  }>
}

export type Common_AnalysisReportResponseValue_Fragment_GqlStringType_Fragment =
  { __typename: 'GQLStringType'; stringValue?: string | null }

export type Common_AnalysisReportResponseValue_Fragment_LogoUrlValue_Fragment =
  { __typename: 'LogoURLValue'; logoURLValue: string }

export type Common_AnalysisReportResponseValue_Fragment_Remarks_Fragment = {
  __typename: 'Remarks'
  remarksValue?: string | null
}

export type Common_AnalysisReportResponseValue_Fragment_TitleValue_Fragment = {
  __typename: 'TitleValue'
  titleValue: string
}

export type Common_AnalysisReportResponseValue_FragmentFragment =
  | Common_AnalysisReportResponseValue_Fragment_GqlDateTimeType_Fragment
  | Common_AnalysisReportResponseValue_Fragment_GqlFloatType_Fragment
  | Common_AnalysisReportResponseValue_Fragment_GqlIntType_Fragment
  | Common_AnalysisReportResponseValue_Fragment_GqlListTag_Fragment
  | Common_AnalysisReportResponseValue_Fragment_GqlStringType_Fragment
  | Common_AnalysisReportResponseValue_Fragment_LogoUrlValue_Fragment
  | Common_AnalysisReportResponseValue_Fragment_Remarks_Fragment
  | Common_AnalysisReportResponseValue_Fragment_TitleValue_Fragment

export type Common_AnalysisReportResponse_FragmentFragment = {
  __typename: 'AnalysisReportResponse'
  configId: string
  analysisReportResponseValue:
    | { __typename: 'GQLDateTimeType'; DateTimeValue?: string | null }
    | { __typename: 'GQLFloatType'; floatValue?: number | null }
    | { __typename: 'GQLIntType'; IntValue?: number | null }
    | {
        __typename: 'GQLListTag'
        tags: Array<{
          __typename: 'Tag'
          tagId: string
          name: string
          color?: Types.ColorEnum | null
          order: number
        }>
      }
    | { __typename: 'GQLStringType'; stringValue?: string | null }
    | { __typename: 'LogoURLValue'; logoURLValue: string }
    | { __typename: 'Remarks'; remarksValue?: string | null }
    | { __typename: 'TitleValue'; titleValue: string }
}

export type Common_AnalysisReport_FragmentFragment = {
  __typename: 'AnalysisReport'
  reportId: string
  responses: Array<{
    __typename: 'AnalysisReportResponse'
    configId: string
    analysisReportResponseValue:
      | { __typename: 'GQLDateTimeType'; DateTimeValue?: string | null }
      | { __typename: 'GQLFloatType'; floatValue?: number | null }
      | { __typename: 'GQLIntType'; IntValue?: number | null }
      | {
          __typename: 'GQLListTag'
          tags: Array<{
            __typename: 'Tag'
            tagId: string
            name: string
            color?: Types.ColorEnum | null
            order: number
          }>
        }
      | { __typename: 'GQLStringType'; stringValue?: string | null }
      | { __typename: 'LogoURLValue'; logoURLValue: string }
      | { __typename: 'Remarks'; remarksValue?: string | null }
      | { __typename: 'TitleValue'; titleValue: string }
  }>
}

export type Common_WhatsAppAnalysisTimelineViewReport_FragmentFragment = {
  __typename: 'WhatsAppAnalysisTimelineViewReport'
  deviceId: string
  deviceName: string
  status: Types.WhatsAppDeviceStatus
  startTime: string
  endTime: string
}

export type Common_AnalysisTimelineViewReport_FragmentFragment = {
  __typename: 'WhatsAppAnalysisTimelineViewReport'
  deviceId: string
  deviceName: string
  status: Types.WhatsAppDeviceStatus
  startTime: string
  endTime: string
}

export type Common_GetCdrAnalysisCellTowerReport_FragmentFragment = {
  __typename: 'GetCDRAnalysisCellTowerReport'
  cellTowerId: string
  locationId?: string | null
  report: {
    __typename: 'AnalysisReport'
    reportId: string
    responses: Array<{
      __typename: 'AnalysisReportResponse'
      configId: string
      analysisReportResponseValue:
        | { __typename: 'GQLDateTimeType'; DateTimeValue?: string | null }
        | { __typename: 'GQLFloatType'; floatValue?: number | null }
        | { __typename: 'GQLIntType'; IntValue?: number | null }
        | {
            __typename: 'GQLListTag'
            tags: Array<{
              __typename: 'Tag'
              tagId: string
              name: string
              color?: Types.ColorEnum | null
              order: number
            }>
          }
        | { __typename: 'GQLStringType'; stringValue?: string | null }
        | { __typename: 'LogoURLValue'; logoURLValue: string }
        | { __typename: 'Remarks'; remarksValue?: string | null }
        | { __typename: 'TitleValue'; titleValue: string }
    }>
  }
}

export type CdrCallActivityFragment = {
  __typename: 'CDRCallActivity'
  activityId: string
  communicationActivityType: Types.CdrCommunicationActivityType
  duration: number
  startTime: string
  title?: string | null
}

export type CdrsmsActivityFragment = {
  __typename: 'CDRSMSActivity'
  activityId: string
  communicationActivityType: Types.CdrCommunicationActivityType
  startTime: string
  title?: string | null
}

export type CdrCommunicationActivity_CdrCallActivity_Fragment = {
  __typename: 'CDRCallActivity'
  activityId: string
  communicationActivityType: Types.CdrCommunicationActivityType
  duration: number
  startTime: string
  title?: string | null
}

export type CdrCommunicationActivity_CdrsmsActivity_Fragment = {
  __typename: 'CDRSMSActivity'
  activityId: string
  communicationActivityType: Types.CdrCommunicationActivityType
  startTime: string
  title?: string | null
}

export type CdrCommunicationActivityFragment =
  | CdrCommunicationActivity_CdrCallActivity_Fragment
  | CdrCommunicationActivity_CdrsmsActivity_Fragment

export type GetWhatsAppAnalysisIpAddressReportFragment = {
  __typename: 'GetWhatsAppAnalysisIpAddressReport'
  ipAddress: string
  locationId?: string | null
  report: {
    __typename: 'AnalysisReport'
    reportId: string
    responses: Array<{
      __typename: 'AnalysisReportResponse'
      configId: string
      analysisReportResponseValue:
        | { __typename: 'GQLDateTimeType'; DateTimeValue?: string | null }
        | { __typename: 'GQLFloatType'; floatValue?: number | null }
        | { __typename: 'GQLIntType'; IntValue?: number | null }
        | {
            __typename: 'GQLListTag'
            tags: Array<{
              __typename: 'Tag'
              tagId: string
              name: string
              color?: Types.ColorEnum | null
              order: number
            }>
          }
        | { __typename: 'GQLStringType'; stringValue?: string | null }
        | { __typename: 'LogoURLValue'; logoURLValue: string }
        | { __typename: 'Remarks'; remarksValue?: string | null }
        | { __typename: 'TitleValue'; titleValue: string }
    }>
  }
}

export type WhatsAppAnalysisIpAddressesFragment = {
  __typename: 'WhatsAppAnalysisIPAddresses'
  ipAddress: string
  firstSeen?: string | null
  lastSeen?: string | null
  ipAddressType: Types.IpAddressType
  anonymousType?: string | null
}

export const Common_AnalysisLocationInSightType_FragmentFragmentDoc = gql`
  fragment Common_AnalysisLocationInSightType_Fragment on AnalysisLocationInSightType {
    locationInsightType
    columnIds
  }
`
export const Common_CdrAnalysis_FragmentFragmentDoc = gql`
  fragment Common_CDRAnalysis_Fragment on CDRAnalysis {
    analysisId
    title
    telecomServiceProvider
    dataReceivedAt
  }
`
export const Common_TelegramAnalysis_FragmentFragmentDoc = gql`
  fragment Common_TelegramAnalysis_Fragment on TelegramAnalysis {
    analysisId
    analysisType
    title
    dataReceivedAt
  }
`
export const Common_WhatsAppAnalysis_FragmentFragmentDoc = gql`
  fragment Common_WhatsAppAnalysis_Fragment on WhatsAppAnalysis {
    analysisId
    analysisType
    title
    dataReceivedAt
    dateRange {
      startDatetime
      endDatetime
    }
  }
`
export const Common_AnalysisTab_FragmentFragmentDoc = gql`
  fragment Common_AnalysisTab_Fragment on AnalysisTab {
    tabId
    title
    sectionIds
  }
`
export const Common_AnalysisSection_FragmentFragmentDoc = gql`
  fragment Common_AnalysisSection_Fragment on AnalysisSection {
    sectionId
    title
    description
    layoutIds
  }
`
export const Common_AnalysisLayout_FragmentFragmentDoc = gql`
  fragment Common_AnalysisLayout_Fragment on AnalysisLayout {
    layoutId
    layoutType
    title
    description
    columnIds
  }
`
export const Common_AnalysisLayoutColumn_FragmentFragmentDoc = gql`
  fragment Common_AnalysisLayoutColumn_Fragment on AnalysisLayoutColumn {
    columnId
    columnName
    columnType
  }
`
export const Common_AnalysisViewConfig_FragmentFragmentDoc = gql`
  fragment Common_AnalysisViewConfig_Fragment on AnalysisViewConfig {
    tabs {
      ...Common_AnalysisTab_Fragment
    }
    sections {
      ...Common_AnalysisSection_Fragment
    }
    layouts {
      ...Common_AnalysisLayout_Fragment
    }
    columns {
      ...Common_AnalysisLayoutColumn_Fragment
    }
  }
  ${Common_AnalysisTab_FragmentFragmentDoc}
  ${Common_AnalysisSection_FragmentFragmentDoc}
  ${Common_AnalysisLayout_FragmentFragmentDoc}
  ${Common_AnalysisLayoutColumn_FragmentFragmentDoc}
`
export const Common_WhatsAppAnalysisTimelineViewReport_FragmentFragmentDoc = gql`
  fragment Common_WhatsAppAnalysisTimelineViewReport_Fragment on WhatsAppAnalysisTimelineViewReport {
    deviceId
    deviceName
    status
    startTime
    endTime
  }
`
export const Common_AnalysisTimelineViewReport_FragmentFragmentDoc = gql`
  fragment Common_AnalysisTimelineViewReport_Fragment on AnalysisTimelineViewReport {
    ... on WhatsAppAnalysisTimelineViewReport {
      ...Common_WhatsAppAnalysisTimelineViewReport_Fragment
    }
  }
  ${Common_WhatsAppAnalysisTimelineViewReport_FragmentFragmentDoc}
`
export const Common_Tag_FragmentFragmentDoc = gql`
  fragment Common_Tag_Fragment on Tag {
    tagId
    name
    color
    order
  }
`
export const Common_AnalysisReportResponseValue_FragmentFragmentDoc = gql`
  fragment Common_AnalysisReportResponseValue_Fragment on AnalysisReportResponseValue {
    ... on GQLStringType {
      stringValue: value
    }
    ... on GQLIntType {
      IntValue: value
    }
    ... on GQLFloatType {
      floatValue: value
    }
    ... on GQLDateTimeType {
      DateTimeValue: value
    }
    ... on Remarks {
      remarksValue: value
    }
    ... on GQLListTag {
      tags {
        ...Common_Tag_Fragment
      }
    }
    ... on TitleValue {
      titleValue: value
    }
    ... on LogoURLValue {
      logoURLValue: value
    }
  }
  ${Common_Tag_FragmentFragmentDoc}
`
export const Common_AnalysisReportResponse_FragmentFragmentDoc = gql`
  fragment Common_AnalysisReportResponse_Fragment on AnalysisReportResponse {
    configId
    analysisReportResponseValue {
      ...Common_AnalysisReportResponseValue_Fragment
    }
  }
  ${Common_AnalysisReportResponseValue_FragmentFragmentDoc}
`
export const Common_AnalysisReport_FragmentFragmentDoc = gql`
  fragment Common_AnalysisReport_Fragment on AnalysisReport {
    reportId
    responses {
      ...Common_AnalysisReportResponse_Fragment
    }
  }
  ${Common_AnalysisReportResponse_FragmentFragmentDoc}
`
export const Common_GetCdrAnalysisCellTowerReport_FragmentFragmentDoc = gql`
  fragment Common_GetCDRAnalysisCellTowerReport_Fragment on GetCDRAnalysisCellTowerReport {
    cellTowerId
    locationId
    report {
      ...Common_AnalysisReport_Fragment
    }
  }
  ${Common_AnalysisReport_FragmentFragmentDoc}
`
export const CdrCallActivityFragmentDoc = gql`
  fragment CDRCallActivity on CDRCallActivity {
    activityId
    communicationActivityType
    duration
    startTime
    title
  }
`
export const CdrsmsActivityFragmentDoc = gql`
  fragment CDRSMSActivity on CDRSMSActivity {
    activityId
    communicationActivityType
    startTime
    title
  }
`
export const CdrCommunicationActivityFragmentDoc = gql`
  fragment CDRCommunicationActivity on CDRCommunicationActivity {
    ... on CDRCallActivity {
      ...CDRCallActivity
    }
    ... on CDRSMSActivity {
      ...CDRSMSActivity
    }
  }
  ${CdrCallActivityFragmentDoc}
  ${CdrsmsActivityFragmentDoc}
`
export const GetWhatsAppAnalysisIpAddressReportFragmentDoc = gql`
  fragment GetWhatsAppAnalysisIPAddressReport on GetWhatsAppAnalysisIpAddressReport {
    ipAddress
    locationId
    report {
      ...Common_AnalysisReport_Fragment
    }
  }
  ${Common_AnalysisReport_FragmentFragmentDoc}
`
export const WhatsAppAnalysisIpAddressesFragmentDoc = gql`
  fragment WhatsAppAnalysisIPAddresses on WhatsAppAnalysisIPAddresses {
    ipAddress
    firstSeen
    lastSeen
    ipAddressType
    anonymousType
  }
`
